// extracted by mini-css-extract-plugin
export var container = "_mc-0";
export var dotAnimation = "_mc-2";
export var dotsLoading = "_mc-1";